import glam from 'glamorous';
import { BrandonGrotesque } from 'module/View/Common';

export const CategoryTextWrapper = glam.div({
  fontFamily: BrandonGrotesque.regularItalic,
  fontStyle: 'normal',
  fontWeight: 'normal',
  fontSize: '1.4rem',
  margin: '0.2rem 0',
});

export const CategoryLinkWrapper = glam.a({
  color: 'inherit',
  fontFamily: BrandonGrotesque.regularItalic,
  fontStyle: 'normal',
  fontWeight: 'normal',
});

export const ClientTextWrapper = glam.div({
  fontSize: '1.4rem',
  fontFamily: BrandonGrotesque.medium,
  fontStyle: 'normal',
  fontWeight: 'normal',
  margin: '0.2rem 0',
  marginBottom: '1.1rem',
});

export const ClientLinkWrapper = glam.a({
  color: 'inherit',
  fontFamily: BrandonGrotesque.medium,
  fontStyle: 'normal',
  fontWeight: 'normal',
});



// WEBPACK FOOTER //
// ./src/module/View/Publication/PublicationDescription/CategoryLink.s.ts